import { useContext } from "react";
import Context from "../../../../context";
import {
  CustomBadges,
  CustomIcon,
  TableNullData,
  UserInformation,
} from "../../../../components";
import { ICreateAndUpdateClient } from "../../../../types/client.interface";

const Body = (data: any) => {
  const { resultClient, setSelectedClient, setShowModal } = useContext(
    Context.ClientScreen
  );

  const clients = resultClient?.data?.result?.docs;

  const onDetail = (driver: ICreateAndUpdateClient) => {
    setSelectedClient!(driver);
    setShowModal!("DETAIL");
  };
  const onUpdate = (driver: ICreateAndUpdateClient) => {
    setSelectedClient!(driver);
    setShowModal!("UPDATE");
  };
  const onDelete = (driver: ICreateAndUpdateClient) => {
    setSelectedClient!(driver);
    setShowModal!("DELETE");
  };

  if (clients?.length <= 0 || !data) return <TableNullData />;
  return (
    <tbody id="driver-table-body-container">
      {clients?.map((client: any, index: number) => {
        return (
          <tr key={`driver-${index}`}>
            <td className="pointer">
              <UserInformation
                avatar={client?.avatar}
                name={client?.firstName}
                lastName={client?.lastName}
                phoneNumber={client?.phoneNumber}
              />
            </td>
            <td>{client?.address?.[0]?.completeAddress}</td>
            <td className="pointer">
              <CustomBadges
                title={
                  client?.isCompleteRegistration ? "تکمیل شده" : "تکمیل نشده"
                }
                type={client?.isCompleteRegistration ? "success" : "danger"}
              />
            </td>
            {/* Status */}

            {/* actions */}
            <td>
              <div className="table-actions-buttons">
                {/* Edit Icon */}
                <CustomIcon
                  icon="fas fa-location-dot"
                  hoverTitle="موقعیت مکانی"
                  onClick={() => onDetail(client)}
                />
                <CustomIcon
                  icon="fas fa-pen"
                  hoverTitle="ویرایش"
                  onClick={() => onUpdate(client)}
                />
                <CustomIcon
                  icon="fas fa-trash"
                  hoverTitle="حذف"
                  onClick={() => onDelete(client)}
                />
              </div>
            </td>
          </tr>
        );
      })}
    </tbody>
  );
};

export default Body;
